import * as types from '../types';
import * as api from '~/api/index';
import * as userApi from '~/api/user';
import * as adApi from '~/api/ad';
export const state = () => {
  return {
    dtbList: null,
    purDtbList: null,
    advertisement: {
      indexBanner: null,
      detailfooterBanner: null,
      indexTopOperation: null,
      indexBottomOperation: null,
    },
  };
};

export const mutations = {
  // TODO: 这里定义一个方法去处理登录状态，理论上这个是多余的，应该用user.js的方法，待优化
  SERVER_ISLOGIN(state, data) {
    state.user.isLogin = data;
  },
  [types.INIT_ADVERTISEMENT](state, data) {
    if (!data) return;
    state.advertisement = data && data.data ? data.data : null;
  },
};

export const actions = {
  // warn 没事别在这里初始化数据 这里每个页面都会请求
  async nuxtServerInit({ commit, dispatch }, { $axios }) {
    const [userInfo, advertisement, adNavBg] = await Promise.all([
      $axios(api.getUserInfo({})).catch(() => ({})), // 用户信息接口
      $axios(api.getAdvertisement()).catch(() => ({})), // 广告接口
      $axios(adApi.GetAdByType(23)).catch(() => ({})), // 广告接口
    ]);
    if (adNavBg.result && adNavBg.result.length > 0) {
      advertisement.data = advertisement.data || {};
      advertisement.data.adNavBg = adNavBg.result[0];
    }
    if (userInfo.result) {
      commit(`user/${types.SET_LOGININFO}`, userInfo.result);
      dispatch('user/updateVipMemberInfo', userInfo.result.svip);
      const followData = await $axios(
        userApi.getFollowings({
          id: userInfo.result.id,
          page: 1,
          count: 500,
        })
      );
      if (followData.result) {
        const ids = followData.result.map(user => {
          return user.id;
        });
        commit(`user/${types.UPDATE_FOLLOWS}`, ids);
      }
    }
    if (userInfo.statusCode === 200) {
      commit(types.SERVER_ISLOGIN, true);
    } else {
      commit(types.SERVER_ISLOGIN, false);
    }

    commit(types.INIT_ADVERTISEMENT, advertisement);
  },
};
